import React from 'react'
import { Link } from 'gatsby'
import withApp from '../../components/withApp/withApp'
import Button from '../../components/Button'
import SiteContainer from '../../components/styles/SiteContainer'
import RoamingHeader from '../../components/RoamingHeader'
import SEO from '../../components/Seo'
import {
  Card,
  InfoBlock,
  SubHeading,
  AltPara,
} from '../../components/styles/Roaming'
import { CONFIG } from '../../config'

const Roaming = () => (
  <React.Fragment>
    <SEO
      title="Roaming & international"
      description="Roaming & international"
    />
    <RoamingHeader selected="calling-abroad" />
    <SiteContainer>
      <InfoBlock headingColor="#82c6ff" noImg>
        <div>
          <h2>How it works</h2>
          <SubHeading>
            Buy “Out of plan” add-ons, then{' '}
            <Link to="/pay-as-you-go">pay as you go</Link>.
          </SubHeading>
          <AltPara>
            To call and text abroad from the UK, buy “Out of plan” add-ons then
            pay as you go. The cost depends on the country you want to contact.
          </AltPara>
          <div style={{ display: 'block', margin: '26px auto 30px' }}>
            <Button to="/calling-abroad/countries" color="#82c6ff">
              Check the costs of calling a country
            </Button>
          </div>
        </div>
      </InfoBlock>

      <Card maxWidth="none" copyColor="#fff" headingColor="#82c6ff">
        <h2 className="card-heading">Before you call or text</h2>
        <SubHeading>
          Buy “Out of plan” add-ons, then{' '}
          <Link to="/pay-as-you-go">pay as you go</Link>.
        </SubHeading>
        <p style={{ margin: '20px 0' }}>
          All international calls and texts are paid for with your “Out of plan”
          add-ons.
        </p>
        <a
          href={`${CONFIG.DASHBOARD_URL}/dashboard/cash-addons`}
          target="_blank"
          rel="noopener noreferrer"
        >
          Buy “Out of plan” add-ons
        </a>
      </Card>
    </SiteContainer>
  </React.Fragment>
)

export default withApp(Roaming)
